import { LocaleLabel } from 'modules/templateEditor/common/LocaleLabel/LocaleLabel';
import { Tooltip } from 'ui/tooltip';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext';

import { TemplateDetailsBlock } from './EditableHeader.styled';
import { displayContent } from '../content';

export const SubHeaderLocales = () => {
  const { activeTemplateLocales } = useLocalesQueryContext();

  return (
    <TemplateDetailsBlock>
      <Tooltip
        isUnderlined
        tooltipContent={
          <div>
            {activeTemplateLocales.map((locale, idx) => (
              <LocaleLabel key={idx} locale={locale} />
            ))}
          </div>
        }
      >
        {displayContent.strLocaleCount({ localeCount: activeTemplateLocales.length })}
      </Tooltip>
    </TemplateDetailsBlock>
  );
};
